module.exports = __webpack_public_path__ + "static/media/0016.1e79af1a.jpg";